<template>
	<div
		class="spinner-div"
		:style="{
			top: cTop,
			left: cLeft,
			right: cRight,
			height: cHeight,
			width: cWidth,
			'background-color': cBackground,
			'border-radius': cBorderRadius,
			border: cBorder,
			'z-index': zIndex,
		}"
	>
		<div
			id="mainSpinner"
			class="ios-spinner"
			:style="{
				width: sWidth,
				height: sHeight,
				'margin-top': sMarginTop,
				'background-color': cBackground,
			}"
		>
			<div :style="{ background: sColor }" class="bar1"></div>
			<div :style="{ background: sColor }" class="bar2"></div>
			<div :style="{ background: sColor }" class="bar3"></div>
			<div :style="{ background: sColor }" class="bar4"></div>
			<div :style="{ background: sColor }" class="bar5"></div>
			<div :style="{ background: sColor }" class="bar6"></div>
			<div :style="{ background: sColor }" class="bar7"></div>
			<div :style="{ background: sColor }" class="bar8"></div>
			<div :style="{ background: sColor }" class="bar9"></div>
			<div :style="{ background: sColor }" class="bar10"></div>
			<div :style="{ background: sColor }" class="bar11"></div>
			<div :style="{ background: sColor }" class="bar12"></div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		cTop: {
			default: '',
			type: String,
		},
		cLeft: {
			default: '',
			type: String,
		},
		cRight: {
			default: '',
			type: String,
		},
		cHeight: {
			default: '',
			type: String,
		},
		cWidth: {
			default: '',
			type: String,
		},
		cBackground: {
			default: '#ffffff',
			type: String,
		},
		cBorderRadius: {
			default: '',
			type: String,
		},
		sColor: {
			default: '#8a8d93',
			type: String,
		},
		cBorder: {
			default: '',
			type: String,
		},
		sWidth: {
			default: '50px',
			type: String,
		},
		sHeight: {
			default: '50px',
			type: String,
		},
		sMarginTop: {
			default: '0',
			Type: String,
		},
		zIndex: {
			default: 'auto',
			Type: String,
		},
	},
	data() {
		return {}
	},
}
</script>

<style>
.spinner-div {
	text-align: center;
	position: absolute;
}
#mainSpinner {
	position: relative;
	width: 50px;
	height: 50px;
	display: inline-block;
	padding: 10px;
	border-radius: 10px;
	vertical-align: top;
	margin-top: 4.1px;
}
.ios-spinner div {
	width: 6%;
	height: 16%;
	background: #8a8d93;
	position: absolute;
	left: 49%;
	top: 43%;
	opacity: 0;
	-webkit-border-radius: 50px;
	-webkit-animation: fade 1s linear infinite;
}
@-webkit-keyframes fade {
	from {
		opacity: 1;
	}
	to {
		opacity: 0.25;
	}
}
.ios-spinner div.bar1 {
	-webkit-transform: rotate(0deg) translate(0, -130%);
	-webkit-animation-delay: 0s;
}
.ios-spinner div.bar2 {
	-webkit-transform: rotate(30deg) translate(0, -130%);
	-webkit-animation-delay: -0.9167s;
}
.ios-spinner div.bar3 {
	-webkit-transform: rotate(60deg) translate(0, -130%);
	-webkit-animation-delay: -0.833s;
}
.ios-spinner div.bar4 {
	-webkit-transform: rotate(90deg) translate(0, -130%);
	-webkit-animation-delay: -0.7497s;
}
.ios-spinner div.bar5 {
	-webkit-transform: rotate(120deg) translate(0, -130%);
	-webkit-animation-delay: -0.667s;
}
.ios-spinner div.bar6 {
	-webkit-transform: rotate(150deg) translate(0, -130%);
	-webkit-animation-delay: -0.5837s;
}
.ios-spinner div.bar7 {
	-webkit-transform: rotate(180deg) translate(0, -130%);
	-webkit-animation-delay: -0.5s;
}
.ios-spinner div.bar8 {
	-webkit-transform: rotate(210deg) translate(0, -130%);
	-webkit-animation-delay: -0.4167s;
}
.ios-spinner div.bar9 {
	-webkit-transform: rotate(240deg) translate(0, -130%);
	-webkit-animation-delay: -0.333s;
}
.ios-spinner div.bar10 {
	-webkit-transform: rotate(270deg) translate(0, -130%);
	-webkit-animation-delay: -0.2497s;
}
.ios-spinner div.bar11 {
	-webkit-transform: rotate(300deg) translate(0, -130%);
	-webkit-animation-delay: -0.167s;
}
.ios-spinner div.bar12 {
	-webkit-transform: rotate(330deg) translate(0, -130%);
	-webkit-animation-delay: -0.0833s;
}
</style>
